/* The checkout's form page (prototype .ffm: .flowBack, .fhead, .fields, .formbar), in the telify layer. */
@layer telify {
  .sheet {
    padding-bottom: 72px;
  }

  .back {
    display: inline-flex;
    align-items: center;
    gap: 7px;
    margin-bottom: 26px;
    font-size: 14px;
    color: var(--text-tertiary);
    background: none;
    border: 0;
    padding: 0;
    cursor: pointer;
    font-family: inherit;
  }

  .head {
    display: grid;
    gap: 10px;
  }

  .headTop {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    gap: 20px;
  }

  .name {
    font-family: var(--font-display);
    font-weight: 500;
    font-size: 40px;
    line-height: 1.08;
    letter-spacing: -0.015em;
  }

  .kind {
    margin-top: 8px;
    font-size: 14px;
    color: var(--text-tertiary);
  }

  .count {
    display: grid;
    justify-items: end;
    gap: 7px;
    flex-shrink: 0;
    padding-bottom: 3px;
  }

  .dots {
    display: inline-flex;
    gap: 5px;
  }

  .dots i {
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background: rgba(var(--fg-page-rgb), 0.22);
  }

  .dots i.on {
    background: var(--accent);
  }

  .countLabel {
    font-size: 13px;
    color: var(--text-tertiary);
    white-space: nowrap;
  }

  .desc {
    font-size: 16px;
    line-height: 1.6;
    color: var(--text-secondary);
    max-width: 60ch;
  }

  .fields {
    margin-top: 30px;
  }

  .bar {
    margin-top: 32px;
    padding-top: 26px;
    border-top: var(--line);
  }

  .submit {
    width: 100%;
  }
}

.submitError {
  margin: 0 0 12px;
  font-size: 14px;
  color: var(--danger);
}
